import {
  getLeoUuid,
  LeoUUID,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { SurveyIdAndName, SurveyIdAndNameDTO } from "../types/surveyIdAndName";
/* eslint-disable import/export */
export abstract class GetProjectSurveyNamesRPC implements
  LeoRPC<GetProjectSurveyNamesRPC.Request, GetProjectSurveyNamesRPC.Response, GetProjectSurveyNamesRPC.Errors.Errors>
{
  abstract execute(
    request: GetProjectSurveyNamesRPC.Request
  ): Promise<LeoRPCResult<GetProjectSurveyNamesRPC.Response, GetProjectSurveyNamesRPC.Errors.Errors>>;
}

export namespace GetProjectSurveyNamesRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    projectId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetProjectSurveyNamesRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
  
  
    constructor(
    projectId: LeoUUID
    ) {
      this.projectId = projectId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      return new Request(
        projectId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetProjectSurveyNamesRPC(projectId='${this.projectId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    surveyIdAndNames: SurveyIdAndNameDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetProjectSurveyNamesResponse: boolean = true;
  
    readonly surveyIdAndNames: SurveyIdAndName[];
  
  
    constructor(
    surveyIdAndNames: SurveyIdAndName[]
    ) {
      this.surveyIdAndNames = surveyIdAndNames;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const surveyIdAndNames = getList<SurveyIdAndNameDTO, SurveyIdAndName>(
        dto,
        "surveyIdAndNames",
        SurveyIdAndName.fromDTO,
        InvalidResponseSurveyIdAndNamesError
      );
      return new Response(
        surveyIdAndNames
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          surveyIdAndNames: this.surveyIdAndNames.map((e: SurveyIdAndName) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetProjectSurveyNames(surveyIdAndNames='${this.surveyIdAndNames}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetProjectSurveyNamesRPC.INVALID_PROJECT_ID()`;
    };
    

    export type Errors = InvalidProjectId;
    export type ErrorsDTO = InvalidProjectIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetProjectSurveyNamesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidResponseSurveyIdAndNamesError extends GetProjectSurveyNamesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseSurveyIdAndNamesError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetProjectSurveyNamesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

